import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const piEditIssueEmbedRoute: InvariantJiraRoute = {
	name: 'pi-issue-edit-embed',
	path: '/jira/issues/edit/pi/embed',
};
